module.exports = __webpack_public_path__ + "img/5-3.9f1372ba.svg";